
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorPointer as ObiCursorPointerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-pointer.js';
 
 
 

 
 export const ObiCursorPointer = createComponent({
   react: React,
   tagName: 'obi-cursor-pointer',
   elementClass: ObiCursorPointerElement,
   events: {
     
   }
  });
 
 